import { GenericVehicleDetails } from '../core';
import { CampaignCardProps } from './hooks/useCampaignCards';

export enum ItemType {
  CAMPAIGN_CARD = 'campaignCard',
  VEHICLE = 'vehicle',
  MODEL_CARD = 'modelCard',
}

export type VehicleWithType = GenericVehicleDetails & {
  type: ItemType.VEHICLE;
};

export type CampaignCardWithType = CampaignCardProps & {
  type: ItemType.CAMPAIGN_CARD;
};

export type CombinedItem =
  | CampaignCardWithType
  | VehicleWithType
  | ModelCardWithType;

export const isModelCard = (item: CombinedItem): item is ModelCardWithType => {
  return item.type === ItemType.MODEL_CARD;
};

export type ModelCardWithType = {
  brand: string;
  model: string;
  imageURL: string;
  configsCount: number;
  displayPrice: number;
  vehicle: GenericVehicleDetails;
  type: ItemType.MODEL_CARD;
};

export type VehicleDealInfo = {
  vehicleId: string;
  term?: number;
  kilometerPackage?: number;
  monthlyPrice: number;
  vehicleBrand: string;
  vehicleCartype: string;
  vehicleModel: string;
  vehicleColor?: string;
  list?: string;
  position?: number;
  minPrice?: number;
  gearshift?: string;
  stock?: number;
  label?: string;
  dealId?: number;
  color?: string;
  driveType?: string;
  contactId?: number;
  paymentMethod?: string;
  customerType?: string;
};

export type FirstVehicleImageAsBase64 = {
  lgImage: string;
  mdImage: string;
  smImage: string;
};

export type VehiclePictureUrlOnly = {
  picture: {
    url: string;
  };
};

export type CompanyDiscount = 0 | 0.3 | 0.5 | 0.8;
